var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedDate, FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import { Card, CardHeader, CardFooter, NavItem, Nav, NavLink, TabContent, TabPane, ModalBody, ModalFooter, Modal, ModalHeader, Form, FormGroup, Label, Input, Badge, CardBody } from 'reactstrap';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import Signals from '../../../signals/Signals';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import { FormErrorContext } from '../../../FormErrorContext';
import FormField from '../../components/ui/FormField/FormField';
import { EmptyDivRow } from '../../components/ui/EmptyRow/EmptyRow';
import GetOrganisationUsersCommand from '../../../commands/organisations/GetOrganisationUsersCommand';
import InviteOrganisationUserCommand from '../../../commands/organisations/InviteOrganisationUserCommand';
import DeleteOrganisationUserCommand from '../../../commands/organisations/DeleteOrganisationUserCommand';
import DeleteInviteOrganisationUserCommand from '../../../commands/organisations/DeleteInviteOrganisationUserCommand';
import UpdateUserRoleCommand from '../../../commands/organisations/UpdateUserRoleCommand';
import { Roles } from '../../../data/Roles';
/**
 *
 */
var Users = /** @class */ (function (_super) {
    __extends(Users, _super);
    /**
     *
     */
    function Users(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            activeTab: 1,
            showInviteModal: false
        };
        _this.onSubmitInvite = _this.onSubmitInvite.bind(_this);
        _this.onResendInvite = _this.onResendInvite.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onSearchChange = _this.onSearchChange.bind(_this);
        _this.onRemoveUser = _this.onRemoveUser.bind(_this);
        _this.onRemoveInvite = _this.onRemoveInvite.bind(_this);
        _this.OnUpgradeUser = _this.OnUpgradeUser.bind(_this);
        return _this;
    }
    /**
     *
     */
    Users.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    Users.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     * @param nextProps
     * @param nextContext
     */
    Users.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        this.initialize();
    };
    /**
     *
     */
    Users.prototype.initialize = function () {
        var _a = this.context, session = _a.session, userCollection = _a.userCollection, inviteCollection = _a.inviteCollection;
        var user = session.user;
        var command = new GetOrganisationUsersCommand();
        command.execute(user.organisation, userCollection, inviteCollection);
    };
    /**
     *
     * @returns {*}
     */
    Users.prototype.render = function () {
        var _this = this;
        var intl = this.props.intl;
        var _a = this.context, session = _a.session, userCollection = _a.userCollection, inviteCollection = _a.inviteCollection;
        if (!session.isLoggedIn) {
            return null;
        }
        var _b = this.state, showInviteModal = _b.showInviteModal, submitting = _b.submitting, errors = _b.errors, activeTab = _b.activeTab;
        return (React.createElement(Page, { pageName: "users" },
            React.createElement("div", { className: "pb-4 h-100" },
                React.createElement(Card, { className: "mh-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                    React.createElement(CardHeader, { className: "flex-column flex-shrink-0 align-items-start" },
                        React.createElement("h1", { className: "card-header-title" },
                            React.createElement(FormattedMessage, { id: "page.users.title" })),
                        React.createElement(Nav, { tabs: true, className: "border-0" },
                            React.createElement(NavItem, null,
                                React.createElement(NavLink, { className: classNames({ active: activeTab === 1 }), onClick: function () {
                                        _this.setState({ activeTab: 1 });
                                    } },
                                    React.createElement(FormattedMessage, { id: "page.users.table.users.title" }),
                                    React.createElement(Badge, { pill: true, color: "soft-primary", className: "ml-2" }, userCollection.list.length))),
                            session.user.isOwner &&
                                React.createElement(NavItem, null,
                                    React.createElement(NavLink, { className: classNames({ active: activeTab === 2 }), onClick: function () {
                                            _this.setState({ activeTab: 2 });
                                        } },
                                        React.createElement(FormattedMessage, { id: "page.users.table.invitations.title" }),
                                        React.createElement(Badge, { pill: true, color: "soft-primary", className: "ml-2" }, inviteCollection.list.length))))),
                    React.createElement(CardBody, { className: "pt-0 mr-4 pr-0 overflow-auto" },
                        React.createElement(TabContent, { activeTab: activeTab },
                            React.createElement(TabPane, { tabId: 1 },
                                React.createElement("div", { className: "table-container w-100 h-100 flex-fill" },
                                    React.createElement("div", { className: "w-100", style: {
                                            display: "grid",
                                            gridTemplateColumns: "2fr 2fr 5fr 1fr 2fr" + (session.user.isOwner ? " 2fr" : ""),
                                            rowGap: "1.3rem",
                                            minWidth: "fit-content"
                                        } },
                                        React.createElement("div", { className: 'w-100 position-sticky text-nowrap text-uppercase bg-secondary px-3 pb-2 table-header', style: { display: "contents", top: 0, zIndex: 1 } },
                                            React.createElement("div", null,
                                                React.createElement(FormattedMessage, { id: "page.users.table.column.firstname" })),
                                            React.createElement("div", null,
                                                React.createElement(FormattedMessage, { id: "page.users.table.column.lastname" })),
                                            React.createElement("div", null,
                                                React.createElement(FormattedMessage, { id: "page.users.table.column.email" })),
                                            React.createElement("div", null,
                                                React.createElement(FormattedMessage, { id: "page.users.table.column.role" })),
                                            React.createElement("div", null,
                                                React.createElement(FormattedMessage, { id: "page.users.table.column.dateadded" })),
                                            session.user.isOwner ?
                                                React.createElement("div", null)
                                                : null),
                                        this._getUserRows()))),
                            session.user.isOwner &&
                                React.createElement(TabPane, { tabId: 2 },
                                    React.createElement("div", { className: "table-container w-100 h-100 flex-fill" },
                                        React.createElement("div", { className: "w-100", style: {
                                                display: "grid",
                                                gridTemplateColumns: "2fr 2fr 5fr 1fr" + (session.user.isOwner ? " 2fr" : ""),
                                                rowGap: "1.3rem",
                                                minWidth: "fit-content"
                                            } },
                                            React.createElement("div", { className: 'w-100 position-sticky text-nowrap text-uppercase bg-secondary px-3 pb-2 table-header', style: { display: "contents", top: 0, zIndex: 1 } },
                                                React.createElement("div", null,
                                                    React.createElement(FormattedMessage, { id: "page.users.table.column.invitationemail" })),
                                                React.createElement("div", null,
                                                    React.createElement(FormattedMessage, { id: "page.users.table.column.invitedby" })),
                                                React.createElement("div", null,
                                                    React.createElement(FormattedMessage, { id: "page.users.table.column.date.invited" })),
                                                React.createElement("div", null,
                                                    React.createElement(FormattedMessage, { id: "page.users.table.column.date.expired" })),
                                                session.user.isOwner ? React.createElement("div", null) : null),
                                            this._getInviteRows()))))),
                    session.user.isOwner &&
                        React.createElement(CardFooter, { className: "d-flex justify-content-end" },
                            React.createElement("button", { className: "btn btn-primary", type: "submit", onClick: function () {
                                    _this.openInviteModal();
                                } },
                                React.createElement("span", { className: "fe fe-user-plus mr-1" }),
                                React.createElement(FormattedMessage, { id: "page.users.adduser" })))),
                React.createElement(Modal, { isOpen: showInviteModal },
                    React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                        React.createElement(Form, { onSubmit: this.onSubmitInvite },
                            React.createElement(ModalHeader, { toggle: function () { return _this.closeInviteModal(); } },
                                React.createElement("h4", null,
                                    React.createElement(FormattedMessage, { id: "page.users.invitemodal.title" }))),
                            React.createElement(ModalBody, null,
                                React.createElement("fieldset", { disabled: submitting },
                                    React.createElement(FormGroup, null,
                                        React.createElement(FormField, null,
                                            React.createElement(Label, { for: "inviteeEmail" },
                                                React.createElement(FormattedMessage, { id: "page.users.invitemodal.field.email" })),
                                            React.createElement(Input, { name: "inviteeEmail", id: "inviteeEmail", type: "email", onChange: this.onInputChange }))))),
                            React.createElement(ModalFooter, null,
                                React.createElement("button", { type: "button", className: "btn btn-outline-primary", onClick: function () { return _this.closeInviteModal(); } },
                                    React.createElement(FormattedMessage, { id: "page.users.invitemodal.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "page.users.invitemodal.send" })))))))));
    };
    /**
     *
     * @param e
     */
    Users.prototype.onInputChange = function (e) {
        var nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    };
    /**
     *
     * @param event
     */
    Users.prototype.onSubmitInvite = function (event) {
        event.preventDefault();
        if (this.state.submitting) {
            return;
        }
        var session = this.context.session;
        var user = session.user;
        var command = new InviteOrganisationUserCommand();
        command.execute(user.organisation, this.state.inviteeEmail).then(this.onSuccess).catch(this.onError);
        this.setState({ errors: null, submitting: true });
    };
    /**
     *
     * @param event
     */
    Users.prototype.onResendInvite = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var inviteId = event.currentTarget.dataset.id;
        var user = session.user;
        this.setState({ inviteeEmail: inviteId });
        if (this.state.submitting) {
            return;
        }
        var command = new InviteOrganisationUserCommand();
        command.execute(user.organisation, inviteId).then(this.onSuccess).catch(this.onError);
        this.setState({ errors: null, submitting: true });
    };
    /**
     *
     * @param user
     */
    Users.prototype.onSuccess = function (user) {
        var intl = this.props.intl;
        Signals.ShowNotification.dispatch(intl.formatMessage({ id: 'notification.user.invitationsend' }, this.state), 'dark');
        this.setState({ submitting: false, showInviteModal: false, activeTab: 2 });
        // Update data to show invite
        this.initialize();
    };
    /**
     *
     * @param error
     */
    Users.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    /**
     *
     * @param value
     */
    Users.prototype.onSearchChange = function (value) {
        var userCollection = this.context.userCollection;
        userCollection.searchStringFilter.value = value.toLowerCase();
        userCollection.update();
    };
    /**
     *
     * @param event
     */
    Users.prototype.OnUpgradeUser = function (event) {
        var intl = this.props.intl;
        var userCollection = this.context.userCollection;
        var userId = event.currentTarget.dataset.id;
        var session = this.context.session;
        var user = userCollection.findById(userId);
        if (user.userRole === "Default") {
            Signals.ShowConfirmModal.dispatch(intl.formatMessage({ id: 'page.users.upgraderole.confirm.title' }, user), intl.formatMessage({ id: 'page.users.upgraderole.confirm.body' }, user), intl.formatMessage({ id: 'page.users.removeuser.confirm.yes' }, user), intl.formatMessage({ id: 'page.users.removeuser.confirm.no' }, user), function () {
                var command = new UpdateUserRoleCommand();
                command.execute(session.user.organisation.id, user, Roles.OWNER, intl);
            });
        }
        else {
            Signals.ShowConfirmModal.dispatch(intl.formatMessage({ id: 'page.users.downgraderole.confirm.title' }, user), intl.formatMessage({ id: 'page.users.downgraderole.confirm.body' }, user), intl.formatMessage({ id: 'page.users.removeuser.confirm.yes' }, user), intl.formatMessage({ id: 'page.users.removeuser.confirm.no' }, user), function () {
                var command = new UpdateUserRoleCommand();
                command.execute(session.user.organisation.id, user, Roles.DEFAULT, intl);
            });
        }
    };
    /**
     *
     * @param event
     */
    Users.prototype.onRemoveUser = function (event) {
        var intl = this.props.intl;
        var userCollection = this.context.userCollection;
        var userId = event.currentTarget.dataset.id;
        var session = this.context.session;
        var user = userCollection.findById(userId);
        //title, body, confirmText = 'Ok', cancelText = 'Cancel', onConfirm = null, onCancel = null
        Signals.ShowConfirmModal.dispatch(intl.formatMessage({ id: 'page.users.removeuser.confirm.title' }, user), intl.formatMessage({ id: 'page.users.removeuser.confirm.body' }, user), intl.formatMessage({ id: 'page.users.removeuser.confirm.yes' }, user), intl.formatMessage({ id: 'page.users.removeuser.confirm.no' }, user), function () {
            var command = new DeleteOrganisationUserCommand();
            command.execute(session.user.organisation, user, userCollection, intl);
        });
    };
    /**
     *
     * @param event
     */
    Users.prototype.onRemoveInvite = function (event) {
        var intl = this.props.intl;
        var inviteCollection = this.context.inviteCollection;
        var inviteId = event.currentTarget.dataset.id;
        var session = this.context.session;
        var invite = inviteCollection.list.find(function (invite) {
            return invite.inviteeEmail === inviteId;
        });
        Signals.ShowConfirmModal.dispatch(intl.formatMessage({ id: 'page.users.retractinvite.confirm.title' }, invite), intl.formatMessage({ id: 'page.users.retractinvite.confirm.body' }, invite), intl.formatMessage({ id: 'page.users.retractinvite.confirm.yes' }, invite), intl.formatMessage({ id: 'page.users.retractinvite.confirm.no' }, invite), function () {
            var command = new DeleteInviteOrganisationUserCommand();
            command.execute(session.user.organisation, invite, inviteCollection, intl);
        });
    };
    /**
     *
     */
    Users.prototype.openInviteModal = function () {
        this.setState({ showInviteModal: true });
    };
    /**
     *
     */
    Users.prototype.closeInviteModal = function () {
        this.setState({ showInviteModal: false });
    };
    /**
     *
     * @return {*}
     * @private
     */
    Users.prototype._getUserRows = function () {
        var _this = this;
        var _a = this.context, session = _a.session, userCollection = _a.userCollection;
        var classes = classNames({
            'users__row': true,
            "bg-white": true,
            "w-100": true,
            'mb-4': true,
            "pl-3": true,
            "pr-3": true,
            'pt-4': true,
            'pb-4': true,
        });
        if (userCollection.filtered.length === 0) {
            return React.createElement(EmptyDivRow, null);
        }
        return userCollection.filtered.map(function (user) {
            //
            return (React.createElement("div", { style: { display: "contents" }, key: 'user-' + user.email, className: classes },
                React.createElement("div", { className: " pl-4 text-left align-middle" }, user.firstname),
                React.createElement("div", { className: "text-nowrap text-left align-middle" }, user.lastname),
                React.createElement("div", { className: "text-nowrap text-left align-middle" },
                    React.createElement("a", { href: 'mailto:' + user.email }, user.email)),
                React.createElement("div", { className: "text-nowrap text-left align-middle" }, user.userRole),
                React.createElement("div", { className: "pr-4 text-nowrap text-left align-middle" },
                    React.createElement(FormattedDate, { value: user.userJoinedTimestamp, day: "numeric", month: "long", year: "numeric" })),
                session.user.isOwner ?
                    React.createElement("div", { className: "pr-4 align-middle text-nowrap" }, session.user.email !== user.email ?
                        (React.createElement("div", null,
                            user.userRole == "Owner" ?
                                React.createElement("button", { className: "btn btn-sm btn-outline-warning d-block", onClick: _this.OnUpgradeUser, "data-id": user.id },
                                    React.createElement("i", { className: "fe fe-arrow-down" }),
                                    " ",
                                    React.createElement(FormattedMessage, { id: "page.users.downgraderole.confirm.title" }))
                                :
                                    React.createElement("button", { className: "btn btn-sm btn-outline-success d-block", onClick: _this.OnUpgradeUser, "data-id": user.id },
                                        React.createElement("i", { className: "fe fe-arrow-up" }),
                                        " ",
                                        React.createElement(FormattedMessage, { id: "page.users.upgraderole.confirm.title" })),
                            React.createElement("button", { className: "btn btn-sm btn-outline-danger d-block mt-2", onClick: _this.onRemoveUser, "data-id": user.id },
                                React.createElement("i", { className: "fe fe-user-minus" }),
                                " ",
                                React.createElement(FormattedMessage, { id: "page.users.remove" }))))
                        : null)
                    : null));
        });
    };
    /**
     *
     * @return {*}
     * @private
     */
    Users.prototype._getInviteRows = function () {
        var _this = this;
        var _a = this.context, session = _a.session, inviteCollection = _a.inviteCollection;
        var classes = classNames({
            'users-invite__row': true,
            "bg-white": true,
            "w-100": true,
            'mb-4': true,
            "pl-3": true,
            "pr-3": true,
            'pt-4': true,
            'pb-4': true,
        });
        return inviteCollection.filtered.map(function (invite) {
            //
            return (React.createElement("div", { style: { display: "contents" }, key: 'invites-' + invite.inviteeEmail, className: classes },
                React.createElement("div", { className: " pl-4 text-left align-middle" },
                    React.createElement("a", { href: 'mailto:' + invite.inviteeEmail }, invite.inviteeEmail)),
                React.createElement("div", { className: " pl-4 text-left align-middle" },
                    React.createElement("a", { href: 'mailto:' + invite.invitedBy }, invite.invitedBy)),
                React.createElement("div", { className: "pr-4 text-nowrap text-left align-middle" },
                    React.createElement(FormattedDate, { value: invite.createdTimestamp, day: "numeric", month: "long", year: "numeric" })),
                React.createElement("div", { className: "pr-4 text-nowrap text-left align-middle" },
                    React.createElement(FormattedDate, { value: invite.expiryTimestamp, day: "numeric", month: "long", year: "numeric" })),
                session.user.isOwner ?
                    React.createElement("div", { className: "pr-4 align-middle text-nowrap" },
                        React.createElement("button", { className: "btn btn-sm btn-outline-success d-block", onClick: _this.onResendInvite, "data-id": invite.inviteeEmail },
                            React.createElement("i", { className: "fe fe-send" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "page.users.resend.invite" })),
                        React.createElement("button", { className: "btn btn-sm btn-outline-danger d-block mt-2", onClick: _this.onRemoveInvite, "data-id": invite.inviteeEmail },
                            React.createElement("i", { className: "fe fe-trash" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "page.users.retract" }))) :
                    null));
        });
    };
    Users = __decorate([
        observer
    ], Users);
    return Users;
}(React.Component));
Users.contextType = ApplicationContext;
export default injectIntl(Users);
